import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { AdminAnnouncementsList } from "./AdminAnnouncementsList";
import { AdminAnnouncementPage } from "./AdminAnnouncementPage";
import { AdminAnnouncementLandingPage } from "./AdminAnnouncementLandingPage";

const useStyles = makeStyles()((_theme) => ({
	adminLessonsPage: {},
}));

/**
 * Admin Announcements (App2) – router.
 * All routes use app2 components and improve-api.
 */
export const AdminAnnouncementsPage: FC = () => {
	const { classes } = useStyles();

	return (
		<Box className={classes.adminLessonsPage}>
			<Routes>
				<Route index element={<AdminAnnouncementsList />} />
				<Route path="create" element={<AdminAnnouncementPage />} />
				<Route path=":announcementId" element={<AdminAnnouncementLandingPage />} />
				<Route path=":announcementId/edit" element={<AdminAnnouncementPage />} />
			</Routes>
		</Box>
	);
};
